export function getPathName(str) {
    return str.substring(1).split('/').splice(0).join(' / ');
}

export function roundNumber(value, count = 2) {
    const defaultResult = 0;
    if (value) {
        const roundedValue =
            typeof value === 'string' ? parseFloat(value) : value;

        return roundedValue < 0
            ? (Math.floor(Math.abs(value) * 100) * -1) / 100
            : roundedValue.toFixed(count);
    }
    return defaultResult.toFixed(count);
}

export function preventValue(e) {
    if (
        e.code === 'Minus' ||
        e.code === 'NumpadSubtract' ||
        e.code === 'KeyE'
    ) {
        e.preventDefault();
    }
}

export function formatNumber(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
